const About = () => {
    return <div>
        <b>This is About component</b>
    </div>
}

export default About